import React, { useEffect, useState } from "react";
import { Space, Card } from "antd";

import { Button, Form, Input, Select } from "antd";
import ImagePicker from "components/pickers/image/MultiImagePicker";
import ProductOptionService from "services/product_option";
import { useParams, useNavigate } from "react-router";
import { useForm } from "antd/es/form/Form";
import InputNumber from "components/input-number";

const service = new ProductOptionService();

const AddNewProducOption = () => {
  const { id, parentid } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const [listProductOption, setListOption] = useState([]);

  const [isDisableId, setisDisableId] = useState(false);

  const onFinish = async (values) => {
    if (id) {
      var created = await service.updateGeneralInfo(values);
      navigate(`/product_option/edit/${created.parent_id}/${created.id}`);
    } else {
      var created = await service.create(values);
      navigate(`/product_option/edit/${created.parent_id}/${created.id}`);
    }

    console.log("Success:", created);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    loadListProductOption();
    if (id) {
      setisDisableId(true);
      loadData();
    }
  }, [id, parentid]);

  const loadListProductOption = async () => {
    var rs = await service.list();
    //convert select option display
    var listOption = rs.map((item) => {
      return {
        value: item.id,
        label: item.title,
      };
    });

    setListOption(listOption);
  };

  const loadData = async () => {
    var item = await service.get(id, parentid);
    form.setFieldsValue(item);
  };
  return (
    <Form
      form={form}
      name="basic"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <div>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Card
            size="small"
            title="Cấu hình thuộc tính sản phẩm"
            style={{ width: "100%" }}
          >
            <Form.Item
              label="Mã"
              name="id"
              hidden
            >
              <Input disabled={isDisableId}></Input>
            </Form.Item>
            <Form.Item
              label="Tên"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên thuộc tính con",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>

            <Form.Item
              label="Thuộc tính"
              name="parent_id"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thuộc tính ",
                },
              ]}
            >
              <Select
                options={listProductOption}
                disabled={isDisableId}
              ></Select>
            </Form.Item>

            <Form.Item label={null}>
              <Space>
                <Button type="primary" htmlType="submit">
                  {id ? "Cập nhật" : "Tạo thuộc tính con"}
                </Button>
                <Button
                    onClick={()=>{
                        navigate(`/product_option/add`);
                        window.location.reload();
                    }}
                >Tạo mới thuộc tính</Button>
                   <Button
                    onClick={()=>{
                        navigate(`/product_option`);
                        window.location.reload();
                    }}
                >Thoát</Button>
              </Space>
            </Form.Item>
          </Card>
        </Space>
      </div>
    </Form>
  );
};
export default AddNewProducOption;
